import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router';
import { AboutPage, NotFoundPage, RoadworksPage } from '../features/about/StaticPages.tsx';
import { AirPage } from '../features/air/AirPage.tsx';
import { WaterPage } from '../features/water/WaterPage.tsx';
import { HomePage } from '../features/home/HomePage.tsx';
import { AgendaPage } from '../features/events/AgendaPage.tsx';
import { PlacePage, PlacesPage } from '../features/places/PlacesPages.tsx';
import { LegalNoticePage, PrivacyPage, TermsPage } from '../features/legal/LegalPages.tsx';
import { SearchPage } from '../features/search/SearchPage.tsx';
import { TransportPage } from '../features/transport/TransportPage.tsx';
import { SkyPage } from '../features/weather/SkyPage.tsx';
import { lazyChunk } from './lazy-chunk.ts';
import { Layout } from './Layout.tsx';

// La carte plein écran (MapLibre, ~250 Ko) n'est chargée qu'à la demande.
const MapPage = lazy(lazyChunk(() => import('../features/map/MapPage.tsx').then((m) => ({ default: m.MapPage }))));

/** Routes publiques — doivent correspondre au registre shared/seo/pages.ts et à wrangler.jsonc. */
export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="transports" element={<TransportPage />} />
          <Route
            path="carte"
            element={
              <Suspense
                fallback={
                  <div className="container page">
                    <p className="state-message">Chargement de la carte…</p>
                  </div>
                }
              >
                <MapPage />
              </Suspense>
            }
          />
          <Route path="agenda" element={<AgendaPage />} />
          <Route path="travaux" element={<RoadworksPage />} />
          <Route path="lieux" element={<PlacesPage />} />
          <Route path="lieux/:slug" element={<PlacePage />} />
          <Route path="ciel" element={<SkyPage />} />
          <Route path="eau" element={<WaterPage />} />
          <Route path="air" element={<AirPage />} />
          <Route path="recherche" element={<SearchPage />} />
          <Route path="a-propos" element={<AboutPage />} />
          <Route path="mentions-legales" element={<LegalNoticePage />} />
          <Route path="confidentialite" element={<PrivacyPage />} />
          <Route path="cgu" element={<TermsPage />} />

          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
